import { handleRefresh } from '@outputinc/o-logins'
import { provideApolloClient, useMutation } from '@vue/apollo-composable'
import { sentryCapture } from '@/utils/sentry'
import { apolloClient } from '@/utils/apolloClient'
import { useAuthStore } from '@/store/AuthStore'
import refreshQuery from '@/queries/refresh'

const useRefreshAuth = () => {
  const { refresh: refreshToken, challengeId } = useAuthStore()
  const cookieDomain = import.meta.env.VITE_COOKIE_DOMAIN

  const {
    mutate: postRefresh,
    onDone: onRefresh,
    onError: onRefError
  } = provideApolloClient(apolloClient)(() =>
    useMutation(refreshQuery, () => ({
      variables: {
        refreshToken,
        challengeId
      },
      fetchPolicy: 'no-cache'
    }))
  )

  onRefresh(payload => {
    if (!payload.data) {
      // something went wrong, kick to Login
      return
    }

    const {
      refresh: { accessToken, refreshToken }
    } = payload.data

    try {
      handleRefresh({ accessToken, refreshToken }, cookieDomain)
    } catch (err) {
      sentryCapture(err)
    }
  })

  onRefError(err => {
    sentryCapture(err)
  })

  return { postRefresh }
}

export default useRefreshAuth
